module.exports = __webpack_public_path__ + "img/depth-contour-l.62fae026.jpg";